import axios from "@/api/_axios";

export const IMAGE_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
];

export function filterImageFiles(fileList) {
  if (!fileList) {
    return [];
  }

  return Array.from(fileList).filter((file) =>
    IMAGE_MIME_TYPES.includes(file.type)
  );
}

function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event.target.result);
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });
}

function extractImageUrl(data) {
  const url = data?.url ?? data?.src ?? data?.location;

  if (!url) {
    throw new Error("Server response did not include an image URL");
  }

  return url;
}

function formatUploadError(error) {
  const response = error?.response;
  if (response) {
    const statusText = response.statusText || "";
    return new Error(
      `Upload failed: ${response.status}${statusText ? ` ${statusText}` : ""}`
    );
  }

  return error;
}

export async function uploadImageFile(file, uploadUrl) {
  if (!uploadUrl) {
    return readFileAsDataURL(file);
  }

  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axios()({
      method: "post",
      url: uploadUrl,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return extractImageUrl(response.data);
  } catch (error) {
    throw formatUploadError(error);
  }
}
